/**
* @requires ./frc.js
*/

frc.modules.videoCarousel = function($module) {
	var self = this;

	self.init = function() {
		if((typeof Swiper)!="undefined"){

			if (!window.videoCarousel || typeof(window.videoCarousel) !== 'object') {
				window.videoCarousel = new Array();
			}

			let p = new Swiper($module, {
				pagination: ".carousel-pagination",
				paginationClickable: true,
				pagination: {
					el: ".carousel-pagination",
					clickable: true
				},
				navigation: {
					nextEl: ".carousel-next",
					prevEl: ".carousel-prev"
				},
				spaceBetween: 16,
				watchOverflow: true,
				on: {
					slideChange: function() {
						let $currentVideo = $(this.el).find('.swiper-slide-active .video-player.ready');

						with ($currentVideo) {
							if (attr('data-video-state') == 'playing' || attr('data-video-state') == 'buffering') {
								data('frcVideo').pauseVideo();
							}
						}
					}
				}
			});
		}
	}

	self.init();
	return self;
}